import { useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { NOTIFICATIONTYPE } from 'Store/Notification/ActionTypes';
import { getNotification } from 'Store/Notification/Selectors';
import Notification from '../Notification/Notification';

const NotificationAction = ({
    notification
}: any) => {
    const [isActive, setActive] = useState(false);

    const notificationType = useMemo(() => {
        switch (notification.type) {
            case NOTIFICATIONTYPE.SUCCESS:
                return 'success';
            case NOTIFICATIONTYPE.ERROR:
                return 'error';
            default:
                return 'info';
        }
    }, [notification.type]);

    useEffect(() => {
        if (!notification) return;
        if (!notification?.message) return;

        setActive(true);
        setTimeout(() => {
            setActive(false);
        }, 2000);
    }, [notification.time]);

    if (isActive) {
        return <Notification variant={notificationType} position='floating'>
            { notification.message }
        </Notification>;
    }

    return <></>;
}

export default connect((state: any) => ({
    notification: getNotification(state)
}), {})(NotificationAction);